module.exports = __webpack_public_path__ + "static/media/Kuusamo_kuva_500x500.1d470e1a.jpg";